import { useCallback } from "react";
import { UserMenu } from "@iq/models";
import { CiLogout } from "react-icons/ci";
import { FaChevronDown } from "react-icons/fa";
import { MdOutlineSecurity } from "react-icons/md";
import IQLogoSmall from "../assets/icons/IQ_small_logo.svg";
// import SecurityQuestionSetup from "../CRM/components/modals/SecurityQuestionSetup";
import { logout } from "../services/authApi";
import useAuthStore, { getDisplayName } from "../states/authStore";

export default function AppUserMenu({ name, id }) {
	const profile = useAuthStore((state) => state.profile);
	const clearAuth = useAuthStore((state) => state.clearAuth);

	const resolvedName = name || getDisplayName(profile) || "User";
	const resolvedId = id ?? profile?.id ?? null;

	const handleLogout = useCallback(async () => {
		try {
			await logout();
		} catch {
			// Clear client auth state even if the logout request fails.
		} finally {
			clearAuth();
			window.location.assign("/login-client");
		}
	}, [clearAuth]);

	// const renderSecurityQuestionModal = useCallback(
	// 	({ profileId, displayName, close }) => (
	// 		<SecurityQuestionSetup
	// 			profile={{
	// 				id: profileId ?? resolvedId,
	// 				name: displayName || resolvedName,
	// 			}}
	// 			onComplete={close}
	// 			onBack={close}
	// 		/>
	// 	),
	// 	[resolvedId, resolvedName]
	// );

	return (
		<UserMenu
			name={resolvedName}
			id={resolvedId}
			logoSrc={IQLogoSmall}
			logoAlt="IQVentory logo small"
			chevronIcon={<FaChevronDown size={12} />}
			securityActionIcon={<MdOutlineSecurity size={16} strokeWidth={0.4} />}
			logoutActionIcon={<CiLogout size={18} strokeWidth={1.2} />}
			onLogout={handleLogout}
			canUpdateSecurityQuestion={false}
			// renderSecurityQuestionModal={renderSecurityQuestionModal}
		/>
	);
}
